export default "__VITE_ASSET__$zYpsTow__"